<template>
  <vx-card>
    <div class="mb-base mt-4 vx-row justify-between items-top">
      <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
        <span class="text-black text-2xl">Aproval Pengajuan Withdraw Sahabat ZX</span>
      </section>
    </div>
    <main>
      <vs-tabs v-if="jenisList.length !== 0">
        <vs-tab v-for="(item, index) in jenisList" :key="index" :label="item.name">
          <div class="tab-text mt-2">
            <TabelAprovalZIS :jenis_id="item.id"></TabelAprovalZIS>
          </div>
        </vs-tab>
      </vs-tabs>
      <center v-else class="py-6 w-full">
        <h4>Loading...</h4>
      </center>
    </main>
  </vx-card>
</template>

<script>
import TabelAprovalZIS from "@/views/penyaluran/component/TabelAprovalZIS.vue";

const transactionType = [
  {
    id: 1,
    text: "Data Pengeluaran",
  },
  {
    id: 0,
    text: "Data Pemasukan",
  },
];

export default {
  components: {
    TabelAprovalZIS,
  },
  data() {
    return {
      jenisList: [],
      typeSelect: transactionType[1],
      mitra_id: null,
      transactionType,
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
  },
  watch: {
    typeSelect() {
      if (this.typeSelect.id !== 1) {
        this.mitra_id = this.profile.id;
      } else {
        this.mitra_id = null;
      }
    },
  },
  methods: {
    getJenis() {
      this.$store
        .dispatch("transaksi/getJenisTransaksi", {})
        .then((v) => {
          this.jenisList = v.data.filter((v) => v.name != "PPOB" && v.name != "TOP UP");
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  created() {
    if (this.profile.level.id !== 2) {
      this.mitra_id = this.profile.id;
    }

    if (this.$store.state.transaksi.jenisList.length !== 0) {
      if (
        this.$store.state.transaksi.jenisList[0].name === "TOP UP" ||
        this.$store.state.transaksi.jenisList[0].name === "PPOB"
      ) {
        this.jenisList = this.$store.state.transaksi.jenisList.reverse();
      } else {
        this.jenisList = this.$store.state.transaksi.jenisList;
      }
    } else {
      this.getJenis();
    }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
